import permissionMasterDataState from "./permission/reducer";
import usergroupMasterDataState from "./usergroup/reducer";
import userMaster from "./user/reducer";
import companies from "./company/reducer";
import plants from "./plant/reducer";
import workinghours from "./plant-working-hour/reducer";
import profile from "./profile/reducer";
import paymentChannels from "./payment/reducer";
import faq from "./faq/reducer";
import sections from "./section/reducer";
import plantAccounts from "./plant-account/reducer";


const masterdataMangement = {
  permissionMasterDataState,
  usergroupMasterDataState,
  userMaster,
  companies,
  plants,
  workinghours,
  profile,
  paymentChannels,
  faq,
  sections,
  plantAccounts,
};

export default masterdataMangement;
